<script>

export default {
  name: "WithdrawalMixin",
  data: function () {
    return {
      showModalAdd: false,
      formData: {
        currency_id: this.getDefaultCurrency(),
        sum: '',
        type_of_withdrawal: '',
        type_of_withdrawal_id: '',
        requisites: '',
        comment: '',
        contact: '',
        contact_type: '',
        contact_type_id: '',
        full_name: '',
        phone_number: '',
        password: ''
      },
      commissionText: '',
      errorMessage: {
        currency_id: '',
        sum: '',
        requisites: '',
        commentMessage: this.getLocalization('Write a comment to the order'),
        contact_type: '',
        contact: ''
      },
      availableCurrency: [],
      showExtraFieldsForCard: false,
      passwordModal: false,
      usdtTypes: [1, 6, 7, 8, 9],
      usdcTypes: [8, 9]
    };
  },
  methods: {
    async submitForm() {
      await this.doWithStopRequest(() => this.doWithLoader(async () => {
        let response = await this.sendRequest(
            this.routeWithdrawalRequest,
            'post',
            this.formData
        );
        if (response.status === 'error') {
          for(let prop in this.errorMessage){
            this.errorMessage[prop] = '';
          }
          this.errorMessage = response.messages;
          let firstMsg = Object.keys(response.messages)[0];
          if (firstMsg !== 'password' && this.passwordModal) {
            this.passwordModal = false;
            this.toggleShowModalAdd();
          }
          await this.alertMessage(
              response.messages[firstMsg],
              'error'
          );
        }
        if (response.status !== 'error') {
          this.togglePasswordModal()
          this.$root.$emit('add-item',response['data'])
          if (this.showSuccessModal !== undefined) {
            this.showSuccessModal = true;
          } else {
            await this.alertMessage(
                'Withdrawal request created',
                'info'
            );
          }

        }
      }), 'Withdrawal request')
    },
    setTypeOfWithdraw(type) {
      if(type.id == 2){
        this.showExtraFieldsForCard = true
      }else{
        this.showExtraFieldsForCard = false;
      }
      this.formData.type_of_withdrawal = type
      this.formData.type_of_withdrawal_id = type.id
      this.commissionText = type.commissionText
    },
    toggleShowModalAdd() {
      this.showModalAdd = !this.showModalAdd;
    },
    getDefaultCurrency(){
      return Object.values(this.availableCurrencies)[0]['id']
    },
    togglePasswordModal() {
      this.passwordModal = !this.passwordModal;
    },
    showPasswordModal() {
      this.toggleShowModalAdd();
      this.togglePasswordModal();
    }
  },

}
</script>
